
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#245389","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/tick-square"}},[_c('path',{attrs:{"d":"M12.75 31.166h8.5c7.083 0 9.917-2.833 9.917-9.917v-8.5c-.001-7.083-2.834-9.916-9.917-9.916h-8.5c-7.084 0-9.917 2.833-9.917 9.917v8.5c0 7.083 2.833 9.916 9.917 9.916z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.979 17l4.009 4.009 8.033-8.018","opacity":".34"}})])])
          )
        }
      }
    